(function () {
  'use strict';
  LocalStorageService.$inject = ['$rootScope', '$state', '$location', 'NotificationService', 'ControlPauseService'];
  angular.module('MktzapApp.Factories')
    .service('LocalStorageService', LocalStorageService);

  function LocalStorageService ($rootScope, $state, $location, NotificationService, ControlPauseService) {
    this.saveUserPauseState = function (ModelFactory) {
      this.clearUserPauseState();
      localStorage.userPauseService = angular.toJson(ModelFactory);
    };

    this.restoreUserPauseState = function () {
      var object = angular.fromJson(localStorage.userPauseService);
      if (!object || !object.is_paused) {
        if ($rootScope.user_data) {
          if ($rootScope.user_data.session_user) {
            ControlPauseService
              .userIsPaused()
              .$promise
              .then(function (data) {
                localStorage.userPauseService = angular.toJson({ id: $rootScope.user_data.session_user.id, is_paused: data.is_paused });
              })
              .catch(function (error) {
              });
          }
        }
      }
      return object;
    };

    this.clearUserPauseState = function () {
      localStorage.removeItem('userPauseService');
    };

    this.sendToBlockPage = function () {
      $state.go('main.user-in-pause');
    };

    this.sendToChatPage = function () {
      $state.go('main.chat');
    };

    this.retrievePauseState = function () {
      return angular.fromJson(localStorage.userPauseService);
    };

    this.checkInPause = function () {
      var pause = this.retrievePauseState();
      if (pause) {
        if (pause.is_paused) {
          return true;
        } else {
          return false;
        }
      }
    };

    this.lockDist = function () {
      localStorage.lockDist = 1;
    };

    this.unlockDist = function () {
      localStorage.lockDist = 0;
    };

    this.checkDistLock = function () {
      return localStorage.lockDist;
    };
  }
})();
